import { ArrowUpRight, Phone, Star } from "lucide-react";
import { PHOTO_HERO, PHONE_TEL, WHATSAPP_URL, TRUST } from "../data/site";

export default function Hero() {
  return (
    <section
      data-testid="hero-section"
      className="relative overflow-hidden border-b border-black/10 paper-grain"
    >
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 pt-14 md:pt-20 pb-16 md:pb-24">
        <div className="lg:col-span-7 flex flex-col justify-center">
          <div className="reveal reveal-1 overline">
            Top DM, Gastroenterologist in Varanasi
          </div>

          <div
            data-testid="hero-doctor-name"
            className="reveal reveal-1 mt-3 font-display-semibold text-[36px] sm:text-[44px] lg:text-[52px] leading-[1.05] tracking-tight"
          >
            Dr. Indresh Dixit
          </div>

          <h1
            data-testid="hero-headline"
            className="reveal reveal-2 mt-4 font-serif-display text-[34px] sm:text-5xl lg:text-[56px] leading-[1.05] tracking-tight"
          >
            Advanced Gastro, Liver &amp; Endoscopy Care in{" "}
            <span className="text-[#0370AD]">Varanasi.</span>
          </h1>

          <p
            data-testid="hero-subheadline"
            className="reveal reveal-3 mt-7 max-w-xl text-[16px] md:text-[18px] leading-relaxed text-black/65"
          >
            10+ years of dedicated practice in digestive and liver disease.
            Member <strong className="text-black/85">ISG · INASL · SGEI</strong>.
            Quiet, precise, knowledge-led care — no chaos, no second opinions
            needed.
          </p>

          <div className="reveal reveal-4 mt-9 flex flex-wrap items-center gap-4">
            <a
              href={WHATSAPP_URL}
              target="_blank"
              rel="noreferrer"
              data-testid="hero-book-appointment-btn"
              className="btn-primary group"
            >
              Book Appointment
              <ArrowUpRight className="h-4 w-4 arrow" />
            </a>
            <a
              href={PHONE_TEL}
              data-testid="hero-call-now-btn"
              className="btn-ghost group"
            >
              <Phone className="h-4 w-4" /> Call Now
            </a>
          </div>

          <div className="mt-10 flex items-center gap-3 text-[13px] text-black/60">
            <div className="flex">
              {[0, 1, 2, 3, 4].map((i) => (
                <Star
                  key={i}
                  className="h-4 w-4 fill-[#F5B400] text-[#F5B400]"
                />
              ))}
            </div>
            <span data-testid="hero-rating-label">
              <strong className="text-black">{TRUST.rating}</strong> /5 ·{" "}
              {TRUST.reviews} Google Reviews
            </span>
          </div>
        </div>

        <div className="lg:col-span-5 relative">
          <div className="absolute -inset-x-6 -bottom-6 top-10 bg-[#EAF6FD] rounded-[12px] hidden lg:block" />
          <div className="relative">
            <div className="aspect-[4/5] overflow-hidden border border-black/10 rounded-[6px] bg-white">
              <img
                data-testid="hero-doctor-image"
                src={PHOTO_HERO}
                alt="Dr. Indresh Dixit"
                className="h-full w-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -left-6 bg-white border border-black/10 px-5 py-4 rounded-[6px] hidden md:block">
              <div className="text-[11px] tracking-[0.18em] uppercase text-black/55 font-semibold">
                Currently Consulting
              </div>
              <div className="mt-1 font-display-semibold text-2xl">
                Lanka · Chetganj
              </div>
              <div className="text-[12px] text-black/55 mt-0.5">
                2 clinics · 6 days a week
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
